import { Tag, Typography, Space } from "antd";

const { Text } = Typography;
const columns = [
  {
    title: "تاریخ ایجاد",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 130,
    sorter: true,
  },
  {
    title: "عنوان",
    dataIndex: "title",
    key: "title",
    width: 160,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "کد تخفیف",
    dataIndex: "code",
    key: "code",
    width: 160,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "درصد",
    dataIndex: "percent",
    key: "percent",
    width: 100,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "استفاده شده",
    dataIndex: "count",
    key: "count",
    width: 140,
    sorter: true,
  },
  {
    title: "تاریخ انقضا",
    dataIndex: "expiresAt",
    key: "expiresAt",
    sorter: true,
    ellipsis: 140,
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 140,
  },
];

export default columns;
